import InpulseAgent from './chat';

const AgentModule = {
  InpulseAgent,
};

export default AgentModule;
